import * as actionType from "../types/ActionTypes";

const initialState = {
  onlineClass: [],
  postOnlineClass: [],
  error: false,
  isLoading: false,
  isPostLoading: false,
  isUpdateLoading: false,
};

export const OnlineClass = (state = initialState, action) => {
  switch (action.type) {
    case actionType.ONLINE_CLASS_SET_DATA:
      return {
        ...state,
        onlineClass: action.onlineClass,
        error: false,
        isLoading: false,
        isPostLoading: false,
        isUpdateLoading: false,
      };

    case actionType.ONLINE_CLASS_FAIL_DATA:
      return {
        ...state,
        error: action.error,
        isLoading: false,
        isPostLoading: false,
        isUpdateLoading: false,
      };
    case actionType.ONLINE_CLASS_LOADING:
      return {
        ...state,
        isLoading: true,
        error: false,
      };
    case actionType.ONLINE_CLASS_POST_LOADING:
      return {
        ...state,
        isPostLoading: true,
        error: false,
      };
    case actionType.ONLINE_CLASS_UPDATE_LOADING:
      return {
        ...state,
        isUpdateLoading: true,
        error: false,
      };
    case actionType.POST_ONLINE_CLASS_DATA_FAIL:
      return {
        ...state,
        error: action.error,
        isPostLoading: false,
        isUpdateLoading: false,
      };
    case actionType.POST_ONLINE_CLASS_DATA_SUCCESS:
      return {
        ...state,
        isPostLoading: false,
        error: false,
        postOnlineClass: action.postOnlineClass,
      };
    case actionType.UPDATE_ONLINE_CLASS_DATA_FAIL:
      return {
        ...state,
        error: action.error,
        isPostLoading: false,
        isUpdateLoading: false,
      };
    case actionType.UPDATE_ONLINE_CLASS_DATA_SUCCESS:
      return {
        ...state,
        isPostLoading: false,
        error: false,
        isUpdateLoading: false,
      };
    case actionType.UPDATE_ONLINE_CLASS_DATA_START:
      return {
        ...state,
      };

    default:
      return state;
  }
};
